import type { Page } from '@aigc/types';
import {
  mutationOptions,
  queryOptions,
  skipToken,
  type QueryKey,
} from '@tanstack/react-query';
import qs from 'qs';
import { http } from '../common/http-client';
import type {
  BaseTaskDto,
  BatchImageTranslationTaskDto,
  ImageGenerationTaskDto,
  ImageGenerationTaskListInputDto,
  ImageTaskDto,
  ImageTaskListInputDto,
  ImageTranslationTaskDto,
  ImageTranslationTaskListInputDto,
  TaskDto,
  TaskListInputDto,
} from './model';

export function getBaseTaskListQueryKey(): QueryKey {
  return ['任务列表'];
}

export const getImageTaskListQueryOptions = (input: ImageTaskListInputDto) => {
  const query = qs.stringify(input);

  return queryOptions({
    queryKey: [...getBaseTaskListQueryKey(), '历史图片', query],
    queryFn: () =>
      http
        .get('tasks/image', { searchParams: query })
        .json<Page<ImageTaskDto>>(),
  });
};

export const getImageGenerationTaskListQueryOptions = (
  input: ImageGenerationTaskListInputDto,
) => {
  const query = qs.stringify(input);

  return queryOptions({
    queryKey: [...getBaseTaskListQueryKey(), '图片生成', query],
    queryFn: () =>
      http
        .get('tasks/image-generation', { searchParams: query })
        .json<Page<ImageGenerationTaskDto>>(),
  });
};

export const getImageTranslationTaskListQueryOptions = (
  input: ImageTranslationTaskListInputDto,
) => {
  const query = qs.stringify(input);

  return queryOptions({
    queryKey: [...getBaseTaskListQueryKey(), '图片翻译', query],
    queryFn: async () => {
      const data = await http
        .get('tasks/image-translation', {
          searchParams: query,
        })
        .json<Page<ImageTranslationTaskDto | BatchImageTranslationTaskDto>>();
      return data;
    },
  });
};

export const getTaskListQueryOptions = (input?: TaskListInputDto) => {
  const query = qs.stringify(input, {
    arrayFormat: 'repeat',
  });

  return queryOptions({
    queryKey: [...getBaseTaskListQueryKey(), query],
    queryFn: async () => {
      const data = await http
        .get('tasks', {
          searchParams: query,
        })
        .json<{ data: TaskDto[]; total: number }>();
      return data;
    },
  });
};

export const getOneTaskQueryOptions = <T extends BaseTaskDto = TaskDto>(
  task_id?: string,
) =>
  queryOptions({
    queryKey: ['任务详情', task_id],
    queryFn:
      task_id == null
        ? skipToken
        : async () => {
            const data = await http.get(`tasks/${task_id}`).json<T>();
            return data;
          },
  });

export const retryLongVideoGenerationTaskMutaion = mutationOptions({
  mutationKey: getBaseTaskListQueryKey(),
  mutationFn: async (taskId: string) => {
    await http.post(`tasks/${taskId}/retry`);
  },
});

export const cancelVideoTranslationMutation = mutationOptions({
  mutationKey: getBaseTaskListQueryKey(),
  mutationFn: async (taskId: string) => {
    await http.delete(`video/long-video/translate/${taskId}`);
  },
});
